var map = {
	"./article-24px.svg": "iyoT",
	"./avatar-elite.svg": "LIaI",
	"./avatar-pro.svg": "iCJf",
	"./baseline-account_box-24px.svg": "RZ2O",
	"./baseline-account_circle-24px.svg": "P2vm",
	"./baseline-add_box-24px.svg": "P2s9",
	"./baseline-attach_money-24px.svg": "nGqY",
	"./baseline-business-24px.svg": "P+kK",
	"./baseline-cake-24px.svg": "MQqS",
	"./baseline-category-24px.svg": "qjfY",
	"./baseline-chat-24px.svg": "sTUB",
	"./baseline-cloud_download-24px.svg": "1E4+",
	"./baseline-credit_card-24px.svg": "Z11O",
	"./baseline-date_range-24px.svg": "4ZKw",
	"./baseline-event-24px.svg": "UUjw",
	"./baseline-event_note-24px.svg": "C5EN",
	"./baseline-favorite-24px.svg": "Qb+D",
	"./baseline-filter_list-24px.svg": "ehMO",
	"./baseline-gift-24px.svg": "3jTL",
	"./baseline-gift-black-24px.svg": "T1wJ",
	"./baseline-giftcard-24px.svg": "PylQ",
	"./baseline-home-24px.svg": "dA9M",
	"./baseline-insert_comment-24px.svg": "PugY",
	"./baseline-language-24px.svg": "FEnc",
	"./baseline-library_add-24px.svg": "/O4o",
	"./baseline-library_books-24px.svg": "qtJa",
	"./baseline-local_hotel-24px.svg": "QIOW",
	"./baseline-local_offer-24px.svg": "Yj5o",
	"./baseline-mail-24px.svg": "T4yr",
	"./baseline-near_me-24px.svg": "q8qh",
	"./baseline-not_interested-24px.svg": "5SRH",
	"./baseline-people-24px.svg": "qXsv",
	"./baseline-person-24px.svg": "PC+y",
	"./baseline-phonelink_ring-24px.svg": "oPTL",
	"./baseline-pin_drop-24px.svg": "Z0j9",
	"./baseline-place-24px.svg": "wrWX",
	"./baseline-receipt-24px.svg": "Y643",
	"./baseline-schedule-24px.svg": "vLU0",
	"./baseline-send-24px.svg": "LsY9",
	"./baseline-settings-20px.svg": "8BPg",
	"./baseline-shop-24px.svg": "f8J8",
	"./baseline-shopping_basket-24px.svg": "zXJd",
	"./baseline-shopping_cart-24px.svg": "vT9z",
	"./baseline-show_chart-24px.svg": "5aBL",
	"./baseline-smartphone-24px.svg": "kADc",
	"./baseline-stars-24px.svg": "OZGJ",
	"./baseline-store-24px.svg": "8KHS",
	"./baseline-toc-24px.svg": "3MyV",
	"./baseline-undo-24px.svg": "eI8+",
	"./baseline-view_carousel-24px.svg": "Cfwg",
	"./baseline-web-24px.svg": "eYWt",
	"./baseline-work-24px.svg": "p+Jy",
	"./baseline-work_outline-24px.svg": "gn+E",
	"./block-24px.svg": "PrOW",
	"./calendar_today-24px.svg": "IAeo",
	"./channel.svg": "ws2S",
	"./coin.svg": "on7N",
	"./content_paste-24px.svg": "eDMh",
	"./contract.svg": "7us4",
	"./delivery_dining_white_24dp.svg": "h6QO",
	"./diamond.svg": "d1O0",
	"./event_white_24dp.svg": "VNuE",
	"./example.svg": "MMMJ",
	"./eye.svg": "TfVu",
	"./eye_open.svg": "Bi4O",
	"./face-24px.svg": "PGSL",
	"./flag_white_24dp.svg": "hLu4",
	"./form.svg": "6xvN",
	"./format_list_numbered.svg": "woMh",
	"./funnow_vertical_orange.svg": "1/NI",
	"./international.svg": "F9+T",
	"./language.svg": "JYDz",
	"./library_books_24px.svg": "doz/",
	"./menu_book-24px.svg": "TO4V",
	"./movie_black_24dp.svg": "KrPX",
	"./notification.svg": "HKZF",
	"./order-play.svg": "B3J8",
	"./outline-email-24px.svg": "XGoB",
	"./paid_white_24dp.svg": "pkGT",
	"./password.svg": "Kj24",
	"./people.svg": "0Fbn",
	"./person_add_disabled-24px.svg": "kCY+",
	"./publish-24px.svg": "j3su",
	"./rate_review-24px.svg": "xPB4",
	"./receipt-long.svg": "IRWb",
	"./sell.svg": "c9jt",
	"./settings_accessibility.svg": "jQeU",
	"./table.svg": "R/Hx",
	"./title_white_24dp.svg": "aWzX",
	"./tree.svg": "k80C",
	"./trophy.svg": "YX9F",
	"./user.svg": "s7Vf",
	"./visibility_off-24px.svg": "Imwd",
	"./workspace_premium.svg": "oPWE"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Uf/o";